module.exports = "<span data-ng-message=required>Required</span> <span data-ng-message=min>*Positive values only</span>";